import { render, staticRenderFns } from "./potential.vue?vue&type=template&id=10a149b4&scoped=true"
import script from "./potential.vue?vue&type=script&lang=js"
export * from "./potential.vue?vue&type=script&lang=js"
import style0 from "./potential.vue?vue&type=style&index=0&id=10a149b4&prod&lang=scss&scoped=true"
import style1 from "./potential.vue?vue&type=style&index=1&id=10a149b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a149b4",
  null
  
)

export default component.exports